import { connect } from 'react-redux';
import KeyHandler from './key-handler';
import { setPendingScannerInput } from '../reducers/app.reducers';

const mapStateToProps = state => ({

});

const mapDispatchToProps = dispatch => ({
  onDidDetectWord: word => dispatch(setPendingScannerInput(word)),
});

export default connect(mapStateToProps, mapDispatchToProps)(KeyHandler);
